import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("line", {
  x1: "22",
  y1: "12",
  x2: "2",
  y2: "12"
}), ___EmotionJSX("path", {
  d: "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
}), ___EmotionJSX("line", {
  x1: "6",
  y1: "16",
  x2: "6",
  y2: "16"
}), ___EmotionJSX("line", {
  x1: "10",
  y1: "16",
  x2: "10",
  y2: "16"
}));
export default SVG;